import Vue from 'vue';
import ForestShop from './components/ForestShop.vue'
import Slideshow from './components/Slideshow.vue'
import Checkout from './components/Checkout.vue'
import Navbar from './components/Navbar.vue'
import Info from './components/Info.vue'
import Donors from './components/Donors.vue'
import PaginationControls from './components/PaginationControls.vue'
import NewsletterSignup from './components/NewsletterSignup.vue'
import SponsorSignup from './components/SponsorSignup.vue'
import ForestMap from './components/ForestMap.vue'
import SliderWrapper from './components/SliderWrapper.vue'
import VueScrollTo from 'vue-scrollto'
import VModal from 'vue-js-modal'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import './utils/validators.js'
import {version} from '../../package.json';

Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.environment,
  appVersion: version
})
Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
console.log(process.env.ENVIRONMENT)
console.log (process.env.BUGSNAG_API_KEY)
Vue.use(VueScrollTo)
Vue.use(VModal)
Vue.config.globalProperties = Vue.config.globalProperties || {}
Vue.prototype.$oneTimeGift = false;

//Vue.prototype.$KlarnaAsyncCallback = window.klarnaAsyncCallback;
//Vue.prototype.$KlarnaPayments = window.Klarna.Payments.Buttons;
new Vue({
  el: '#app',
  components: {
    'donors': Donors,
    'pagination-controls': PaginationControls,
    'info': Info,
    'forest-shop': ForestShop,
    'slideshow': Slideshow,
    'checkout': Checkout,
    'sponsor-signup': SponsorSignup,
    'navbar': Navbar,
    'slider-wrapper': SliderWrapper,
    'newsletter-signup': NewsletterSignup,
    'forest-map': ForestMap,
  },
  mixins: {
    
  }

})
